// Module
var code = " <div class=\"react-container react-zoom\"> <subscription-financial-aid/> </div> ";
// Exports
module.exports = code;